export const PROJECTS_DATA_COMPACT_FONT_SIZE = '0.8rem';
export const PROJECTS_DATA_FIELD_HEIGHT = 48;
export const PROJECTS_DATA_ROW_HEIGHT = 48;
export const PROJECTS_DATA_HEADER_HEIGHT = 38;
export const PROJECTS_DATA_MIN_WIDTH = 618;
export const PROJECTS_DATA_TEXT_CELL_PADDING_LEFT = 0.75;
export const PROJECTS_DATA_CHECKBOX_PADDING_LEFT = 0.5;
export const PROJECTS_DATA_GRID_TEMPLATE = 'minmax(235px, 2.4fr) minmax(95px, 0.9fr) minmax(95px, 0.9fr) minmax(145px, 1.4fr) 48px';
export const PROJECTS_DATA_COLUMN_WIDTHS = {
  project: 235,
  district: 95,
  region: 95,
  area: 145,
  selection: 48,
} as const;
export const PROJECTS_DATA_SECTION_HEADING_GAP = 1;
export const PROJECTS_DATA_DESCRIPTION_CONTENT_GAP = 2;
export const PROJECTS_DATA_PANEL_GAP = 2.5;
export const PROJECTS_DATA_CANDIDATE_PANEL_FLEX = { xs: 'none', lg: '1.25 1 0' } as const;
export const PROJECTS_DATA_REVIEW_PANEL_FLEX = { xs: 'none', lg: '1 1 0' } as const;
export const PROJECTS_DATA_PANEL_WIDTH = { xs: '100%', lg: 0 } as const;
